<template>
  <div>
    <div class="container">
      <div class="navbar">
        <div class="logo">
          <img src="@/assets/images/logo.svg" />
        </div>
      </div>
      <div class="modal" style="display:unset;">
        <div class="modal-content">
          <div class="modal-body">
            <div class="email leftemail" style="width: 100vh;height: 37vh;">
              <img src="@/assets/images/email.svg" />
              <div class="heading">Bind license key</div>
              <div v-if="error" style="background: #c31818;width: 300px;padding: 20.5px;margin-bottom: 20px;">{{ errorMessage }}</div>
              <div class="formm">
                <label></label>
                <input type="text" placeholder="Enter license key" v-model="licenseKey" />
              </div>
              <span class="extend-btn" v-on:click="bind">Bind</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Bind',
  data () {
    return {
      licenseKey: '',
      submitting: false,
      error: false,
      errorMessage: ''
    }
  },
  methods: {
    bind (e) {
      e.preventDefault()

      if (this.submitting) return
      if (this.licenseKey.trim() == '') return

      this.error = false
      this.errorMessage = ''
      this.submitting = true

      fetch(`/api/v1/user/bind`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ licenseKey: this.licenseKey }),
        credentials: 'include'
      }).then(res => {
        this.submitting = false

        if (res.status == 200) {
          location.href = '/dashboard'
        } else if (res.status == 404) {
          this.errorMessage = 'License key not found!'
          this.error = true
        } else if (res.status == 409) {
          this.errorMessage = 'License key is already bound!'
          this.error = true
        } else if (res.status == 400) {
          this.errorMessage = 'All fields are required!'
          this.error = true
        } else {
          this.errorMessage = 'An unexpected error occurred, please try again later'
          this.error = true
        }
      }).catch(() => {
        this.submitting = false
        this.errorMessage = 'An unexpected error occurred, please try again later'
        this.error = true
      })
    }
  }
}
</script>

<style>
  @import '../../../assets/css/dashboard.css';
</style>
